import React, { useState, useEffect } from 'react'
import UserCard from './userCard'
import { getData, deleteData } from '../../actions'
import { Grid, Button, Grow, TextField, Typography } from '@material-ui/core'
import ArrowBackRoundedIcon from '@material-ui/icons/ArrowBackRounded'
import AdminModal from '../../modal/adminModal'
import Popover from '../../popover/popover'
import AddMany from './addMany'
import UpdateUser from './updateUser'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import InboxIcon from '@material-ui/icons/Inbox'
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded'
import EditRoundedIcon from '@material-ui/icons/EditRounded'
import Snackbar from '../../snackbar/snackbar'
import Filter from '../../filter/filter'

import CircularProgress from '@material-ui/core/CircularProgress'

import { MenuItem, InputLabel, FormControl, Select } from '@material-ui/core'

export default function UserContainer (props) {
  const [users, setUsers] = useState([])
  const [filteredUser, setFilteredUser] = useState([])
  const [addMany, setAddMany] = useState(false)
  const [deleteModal, setDeleteModal] = useState(false)
  const [updateModal, setUpdateModal] = useState(false)
  const [updateModalId, setUpdateModalId] = useState('')
  const [popover, setPopover] = useState([null, ''])
  const [filterPropertyName, setFilterPropertyName] = useState('email')
  const [snackbar, setSnackBar] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    userList()
  }, [])

  const userList = async () => {
    setIsLoading(true)
    let usersObj = []
    const createData = (id, name, email, imageUrl, role, departments) => {
      return { id, name, email, imageUrl, role, departments }
    }
    try {
      const { data } = await getData('/userInfo/userList')
      for (let obj of data) {
        console.log(obj.departments)
        usersObj.push(
          createData(
            obj._id,
            `${obj.firstName} ${obj.lastName}`,
            obj.email,
            obj.imageUrl,
            obj.roles[0],
            obj.departments
          )
        )
      }
      setUsers(usersObj)
      setIsLoading(false)
    } catch (e) {
      console.log(e)
      alert('Oops something went wrong')
      setIsLoading(false)
    }
  }
  const updateUser = (e, id) => {
    setUpdateModal(e)
    setPopover([null, ''])
    setUpdateModalId(id)
  }

  const deleteUser = async id => {
    setIsLoading(true)
    try {
      const { data } = await deleteData(`/userInfo/${id}`, { _id: id })
      if (data.deletedCount > 0) {
        setDeleteModal(false)
        setUpdateModalId('')
        userList()
        if (filteredUser.length > 0) {
          setFilteredUser([])
        }
      } else {
        alert('User not found')
      }
      setIsLoading(false)
    } catch (e) {
      console.log(e.response)
      alert('oops something went wrong')
      setIsLoading(false)
      setUpdateModalId('')
    }
  }

  const modals = (
    <>
      <AdminModal
        title='Confirm deletion'
        open={deleteModal}
        handleClose={() => {
          setDeleteModal(false)
          setUpdateModalId('')
        }}
        actions={
          updateModalId ? (
            <>
              <Button
                color='primary'
                onClick={() => deleteUser(updateModalId)}
                disabled={isLoading}
              >
                Yes
              </Button>
              <Button
                color='primary'
                onClick={() => {
                  setDeleteModal(false)
                  setUpdateModalId('')
                }}
                disabled={isLoading}
              >
                No
              </Button>
            </>
          ) : (
            <CircularProgress size={20} style={{ marginLeft: '46%' }} />
          )
        }
      >
        {deleteModal ? (
          <div>{`Are you sure you want to delete this user?`}</div>
        ) : (
          <></>
        )}
      </AdminModal>
      <AdminModal
        fullScreen={true}
        title='User List'
        open={addMany}
        handleClose={() => {
          setAddMany(false)
        }}
      >
        {addMany ? (
          <AddMany
            existingData={users}
            saveData={userList}
            handleClose={() => {
              setAddMany(false)
            }}
          />
        ) : (
          <></>
        )}
      </AdminModal>
      <AdminModal
        title='User Details'
        fullWidth={true}
        maxWidth='xs'
        open={updateModal}
        handleClose={() => {
          setUpdateModal(false)
          setUpdateModalId('')
        }}
      >
        {updateModal ? (
          <UpdateUser
            id={updateModalId}
            handleClose={status => {
              if (status !== 'Cancel') {
                setSnackBar(true)
                userList()
                if (filteredUser.length > 0) {
                  const userIndex = filteredUser.findIndex(
                    row => row.id === updateModalId
                  )
                  const updatedArray = [...filteredUser]
                  const updatedObj = updatedArray[userIndex]
                  updatedObj.name = status[0]
                  updatedObj.email = status[1]
                  updatedObj.role = status[2]
                  updatedObj.departments = status[3]
                  updatedArray[userIndex] = updatedObj
                  setFilteredUser(updatedArray)
                }
              }
              setUpdateModal(false)
              setUpdateModalId('')
            }}
          />
        ) : (
          <></>
        )}
      </AdminModal>
    </>
  )

  return (
    <>
      {modals}
      <Snackbar
        open={snackbar}
        handleClose={() => {
          setSnackBar(false)
        }}
      >
        Successfully saved
      </Snackbar>
      <Popover anchorEl={popover[0]} handleClose={() => setPopover([null, ''])}>
        <ListItem
          button
          className
          onClick={() => {
            setDeleteModal(true)
            setUpdateModalId(popover[1])
            setPopover([null, ''])
          }}
        >
          <DeleteRoundedIcon color='secondary' />
        </ListItem>
        <ListItem button onClick={() => updateUser(popover[0], popover[1])}>
          <EditRoundedIcon color='primary' />
        </ListItem>
      </Popover>
      <div style={{ padding: '1rem' }}>
        <Button type='button' color='primary' onClick={props.handleBack}>
          <ArrowBackRoundedIcon />
        </Button>
        <Button
          type='button'
          color='primary'
          size='small'
          onClick={() => {
            setAddMany(true)
          }}
        >
          Add User
        </Button>

        <Grid container spacing={2}>
          <Grid item xs={10} sm={10}>
            <Filter
              listData={users}
              filterValue={filteredUser}
              label='Filter'
              propertyName={filterPropertyName}
              onChange={value => setFilteredUser(value)}
            />
          </Grid>
          <Grid item xs={2} sm={2}>
            <FormControl style={{ width: '100%' }}>
              <InputLabel>Categorize</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                fullWidth
                value={filterPropertyName}
                onChange={e => {
                  setFilterPropertyName(e.target.value)
                }}
              >
                <MenuItem value='email'>By Email</MenuItem>
                <MenuItem value='name'>By Name</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </div>

      {isLoading ? (
        <CircularProgress style={{ marginLeft: '46%' }} />
      ) : (
        <Grid container spacing={1}>
          {filteredUser.length > 0
            ? filteredUser.map(
                ({ id, name, email, imageUrl, role, departments }) => {
                  return (
                    <Grow key={id} in={true}>
                      <Grid item xs={12} sm={12}>
                        <UserCard
                          id={id}
                          name={name}
                          imageUrl={imageUrl}
                          email={email}
                          role={role}
                          departments={departments}
                          actions={e => {
                            // updateUser(e, id)
                            setPopover([e, id])
                          }}
                        />
                      </Grid>
                    </Grow>
                  )
                }
              )
            : users.map(({ id, name, email, imageUrl, role, departments }) => {
                return (
                  <Grow key={id} in={true}>
                    <Grid item xs={12} sm={12}>
                      <UserCard
                        id={id}
                        name={name}
                        imageUrl={imageUrl}
                        email={email}
                        role={role}
                        departments={departments}
                        actions={e => {
                          // updateUser(e, id)
                          setPopover([e, id])
                        }}
                      />
                    </Grid>
                  </Grow>
                )
              })}
        </Grid>
      )}
    </>
  )
}
